import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import type { components } from './schema';

type S = components['schemas'];
export type AiUseCase = S['AiUseCase'];
export type AiUseCaseSettings = S['AiUseCaseSettings'];
export type AiUseCaseTemplate = S['AiUseCaseTemplate'];

const key = ['ai', 'use-cases'] as const;

export function useAiUseCases() {
  return useQuery({
    queryKey: key,
    queryFn: ({ signal }) =>
      api<{ data: AiUseCaseSettings }>('/ai/use-cases', { signal }).then((r) => r.data),
  });
}

export function useAiUseCaseTemplates() {
  return useQuery({
    queryKey: [...key, 'templates'],
    staleTime: Infinity,
    queryFn: ({ signal }) =>
      api<{ data: AiUseCaseTemplate[] }>('/ai/use-cases/templates', { signal }).then((r) => r.data),
  });
}

export function useSaveAiUseCases() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { useCases: AiUseCase[]; templateId?: string | null }) =>
      api<{ data: AiUseCaseSettings }>('/ai/use-cases', { method: 'PUT', body: input }).then((r) => r.data),
    onSuccess: (data) => qc.setQueryData(key, data),
  });
}

export function useApplyAiUseCaseTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (templateId: string) =>
      api<{ data: AiUseCaseSettings }>('/ai/use-cases/apply-template', {
        method: 'POST',
        body: { templateId },
      }).then((r) => r.data),
    onSuccess: (data) => qc.setQueryData(key, data),
  });
}
